import React from "react";
import { NavLink } from "react-router-dom";
import "./NavListSingleElement.scss";
import { logoutUser } from "services/authUser";
import { useHistory } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";

const NavListSingleElement = ({
	navigateTo,
	spanContent,
	setMenuStatus,
	iconClassName,
	action,
	setAuth,
	index
}) => {
	const history = useHistory();

	const onSelectOption = () => {
		if (setMenuStatus) {
			setMenuStatus({ left: false });
			window.scrollTo(0, 0);
		}
	};

	const onLogout = () => {
		logoutUser();
		setAuth(false);
		window.localStorage.setItem("countLogin", 1);
		history.push("/");
		window.localStorage.setItem("account", false);
		if (window.innerWidth < 1199) {
			setMenuStatus({ left: false });
		}
	};

	const key = uuidv4();

	return (
		<li className="ul__li--sidebarMenu" key={key} id={key} >
			<NavLink
				activeClassName="ul__li--sidebarMenu__anchor--active"
				className="ul__li--sidebarMenu__anchor"
				to={navigateTo}
				exact
				onClick={action === "close" ? onLogout : onSelectOption}
			>
				<span className="ul_li--sidebarMenu__anchor__navElement">
					<span className={iconClassName}></span>
					<span className="ul__li--sidebarMenu__anchor__navElement__span">
						{spanContent}
					</span>
				</span>
			</NavLink>
		</li>
	);
};

export default NavListSingleElement;
